goog.provide('el8.apphome.docMgr.Organizer');

goog.require('el8.template.render.docMgr');
goog.require('el8.template.render.docMgr.organizer');
goog.require('el8.practicedata.base');
goog.require('el8.practicedata.incomingFileGroups');
goog.require('el8.practicedata.unfiledInboxes');
goog.require('el8.apphome.docMgr.InboxFeed');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.TabbedNav');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.apphome.docMgr.renderer');
goog.require('el8.apphome.docMgr.util');
goog.require('el8.util.dom');
goog.require('el8.util.consts');
goog.require('el8.util.amplitude.documentHelpers');


el8.apphome.docMgr.Organizer = function(spec) {
    this._dialogContainer = spec.dialogContainer;
    this._container = spec.container;
    this._sorter = spec.sorter;
    this._feeds = {};  // feeds key'd off of inboxId
    this._currFeedId = null;
    this._panel = spec.panel;
    this._fileIdMap = {};  // maps uploadedImage, uploadedFileId to inboxId, fileGroupId
    this._showFeedFn = spec.showFeedFn;
    this._sortNewestFirst = false;
    this._showInboxCb = null;
    this._showDeleted = spec.showDeleted || false;
};

el8.apphome.docMgr.Organizer.prototype._init = function(showInboxCb) {

    if (this._isInit) { return; }

    this._initTabs();

    this._showInboxCb = showInboxCb;

    var that = this;
    var allInboxes = el8.practicedata.unfiledInboxes.all();
    allInboxes.map(function(inbox) {
        var $inboxContent = $(el8.template.render.docMgr.organizer.inboxContainer({
            id: inbox.getId()
        }));
        $('.tabbed-nav', that._container).after($inboxContent);
        $inboxContent.hide();

        that._feeds[inbox.getId()] = (new el8.apphome.docMgr.InboxFeed({
            container: $inboxContent,
            dialogContainer: that._dialogContainer,
            organizerContainer: that._container,
            sorter: that._sorter,
            inboxId: inbox.getId(),
            loadFileFn: function(var_args) {
                that.addToFileIdMap.apply(that, arguments);
            },
            removeFileFn: function(var_args) {
                that.removeFromFileIdMap.apply(that, arguments);
            },
            showDeleted: that._showDeleted,
        })).init();
    });

    // set the default sort order
    this.setSortOrder(this._sortNewestFirst);

    $(document).on('click', '.sort-documents-oldest-first-trigger',  function(e) {
        that.setSortOrder(false);
        that.refresh(el8Globals.FEATURES.FaxInboxLimitLoading ? that._currFeedId : undefined);
    });

    $(document).on('click', '.sort-documents-newest-first-trigger',  function(e) {
        that.setSortOrder(true);
        that.refresh(el8Globals.FEATURES.FaxInboxLimitLoading ? that._currFeedId : undefined);
    });

    $(document).on('click', '.show-recently-deleted-documents-trigger',  function(e) {
        that.toggleRecentlyDeleted();
        that.refresh(el8Globals.FEATURES.FaxInboxLimitLoading ? that._currFeedId : undefined);
    });
    
    if (!el8Globals.FEATURES.FaxInboxLimitLoading) {
        that.refresh();
    }

    this._panel.bind('el8_adjustSize', function() {
        if (that._currFeedId) {
            that._feeds[that._currFeedId].adjustSize();
        }
    });

    if (el8Globals.FEATURES.FaxInboxLimitLoading) {
        if (that._showInboxCb) { that._showInboxCb(); }
    }

    this._isInit = true;
};

el8.apphome.docMgr.Organizer.prototype.toggleRecentlyDeleted = function() {
    var that = this;

    var $deletedBtn = $(".show-recently-deleted-documents-trigger");
    this._showDeleted = !that._showDeleted;
    if (that._showDeleted) {
        el8.util.amplitude.logViewRecentlyDeletedFaxes();
        $deletedBtn.addClass('el8ShortcutBarButtonSelected')
    } else {
        $deletedBtn.removeClass('el8ShortcutBarButtonSelected')
    }
    var current_feed = that._feeds[that._currFeedId];
    current_feed._showDeleted = that._showDeleted;
    current_feed.syncShowDeleted();
}

el8.apphome.docMgr.Organizer.prototype.setSortOrder = function(is_newest_first) {
    var $newestFirstBtn = $(".sort-documents-newest-first-trigger");
    var $oldestFirstBtn = $(".sort-documents-oldest-first-trigger");

    if (is_newest_first) {
        $oldestFirstBtn.removeClass('el8ShortcutBarButtonSelected')
        $newestFirstBtn.addClass('el8ShortcutBarButtonSelected')
    }
    else {
        $newestFirstBtn.removeClass('el8ShortcutBarButtonSelected')
        $oldestFirstBtn.addClass('el8ShortcutBarButtonSelected')
    }
    this._sortNewestFirst = is_newest_first;
}

el8.apphome.docMgr.Organizer.prototype.refresh = function(selected_fax_id) {
    var that = this;
    that._container.addClass('el8LargeLoading');

    // Do initial load of index and items
    var url = el8.service.urls.get('unfiledDocumentsInitialFeeds');
    url += "?newest_first=";
    url += that._sortNewestFirst ? 1 : 0;
    if (el8Globals.FEATURES.FaxInboxLimitLoading && selected_fax_id) {
        url += "&practice_fax_id=";
        url += selected_fax_id;
    }
    url += "&return_deleted=" + ( that._showDeleted ? 1 : 0);

    $.el8_ajax({
        url: url,
        type: 'GET',
        success: function(data) {
            el8.practicedata.load(data['items'] || []);
            for (var inboxId in that._feeds) {
                if (that._feeds.hasOwnProperty(inboxId)) {
                    that._feeds[inboxId].loadIndex(data['indexes'][inboxId] || []);
                }
            }
            if (data['pending']) {
                el8.practicedata.load(data['pending']);
                for (var i=0, len=data['pending'].length; i<len; i++) {
                    var pendingItem = data['pending'][i];
                    var feedId = pendingItem.practice_fax_id || 'manual';
                    that._feeds[feedId].updateFileGroupProcessing(pendingItem.id);
                }
            }
            if (el8Globals.FEATURES.FaxInboxLimitLoading && selected_fax_id) {
                that._currFeedId = isNaN(selected_fax_id*1) ? selected_fax_id : selected_fax_id*1;
                that._showFeed(that._currFeedId);
            } else {
                if (that._showInboxCb) { that._showInboxCb(); }
            }
            that._container.removeClass('el8LargeLoading');
        }
    });
}

el8.apphome.docMgr.Organizer.prototype._initTabs = function() {
    var that = this;
    var tabs = el8.practicedata.unfiledInboxes.all().map(function(inbox) {
        return {
            name: inbox.getId(),
            title: inbox.getName() + ' ('+inbox.getDisplayFax()+')',
            updateCountFn: function(name) {
                return el8.practicedata.unfiledInboxes.getById(name).getCount();
            },
            showTabFn: function(name) { return that._showInboxId(name); }
        };
    });
    this._tabbedNav = new el8.uiwidget.TabbedNav();
    this._tabbedNav.init({wrapper: $('.tabbed-nav', this._container)});
    for (var i=0; i<tabs.length; i++) {
        var tabContainer = $('.organizer-inbox[data-id="'+tabs[i].name+'"]', this._container);
        this._tabbedNav.addTab({
            title: tabs[i].title,
            name: tabs[i].name,
            contentDiv: tabContainer,
            updateCountFn: tabs[i].updateCountFn,
            showTabFn: tabs[i].showTabFn
        });
    }
    el8.practicedata.unfiledInboxes.addObserver(function() {
        that._tabbedNav.updateAllTabCounts();
    });
};


/**
 * Main public API's
 */
el8.apphome.docMgr.Organizer.prototype.show = function(inboxId) {
    var that = this;
    var showInboxFn = function() {
        if (inboxId) {
            that._currFeedId = inboxId;
            that._tabbedNav.showTab(inboxId);
        }  else if (!that._currFeedId) {
            // If no inbox selected, and no inbox requested, go to "manual"
            // TODO no way for this to happen now, but may want to intelligently
            // identify default in the future
            that._tabbedNav.showTab('manual');
        } else {
            that._showFeed(that._currFeedId);
        }
    };

    if (!this._isInit) {
        // On initialization, we need to delay showing until
        // an AJAX request returns, but making the whole 'show'
        // synchronous makes the DocMgr very slow to load
        this._init(showInboxFn);
    } else {
        showInboxFn();
    }

};

el8.apphome.docMgr.Organizer.prototype._showInboxId = function (inboxId) {
    // Only request and process items for the _currentFeedId.
    // Generally for enterprise, or customers with tons of fax docs
    if (el8Globals.FEATURES.FaxInboxLimitLoading) {
        this._processFeeds(inboxId);

        // Refresh will refresh data and then set _currFeedId and call _showFeed
        this.refresh(inboxId);
    } else {
        this._processFeeds(inboxId);
        this._currFeedId = isNaN(inboxId * 1) ? inboxId : inboxId * 1;
        this._showFeed(this._currFeedId);
    }
};

/**
 * Hides unselected feeds and resets "_showDeleted" to false if needed
 */
el8.apphome.docMgr.Organizer.prototype._processFeeds = function (inboxId) {
    for (var feedId in this._feeds) {
        // Hide Feed if not currently selected
        if (this._feeds.hasOwnProperty(feedId) && !el8.apphome.docMgr.util.isSameInbox(feedId, inboxId)) {
            this._hideFeed(feedId);

            // If the feed to hide has _showDeleted, reset it and sync showDeleted
            var feed_to_hide = this._feeds[feedId];
            if (feed_to_hide._showDeleted) {
                this._showDeleted = false;
                var $deletedBtn = $(".show-recently-deleted-documents-trigger");
                $deletedBtn.removeClass('el8ShortcutBarButtonSelected');
                feed_to_hide._showDeleted = false;
                feed_to_hide.syncShowDeleted();
            }
        }
    }
};

el8.apphome.docMgr.Organizer.prototype.hide = function() {
    this.pauseHover();
    for (var feedId in this._feeds) {
        if (this._feeds.hasOwnProperty(feedId)) {
             this._hideFeed(feedId);
        }
    }
};

el8.apphome.docMgr.Organizer.prototype.pauseHover = function() {
    if (this._currFeedId) {
        this._feeds[this._currFeedId].pauseHover();
    }
};

el8.apphome.docMgr.Organizer.prototype.refreshCurrent = function() {
    this._feeds[this._currFeedId].update({
        newestFirst: this._sortNewestFirst
    });
};

el8.apphome.docMgr.Organizer.prototype.refreshFileItem = function(fileItem) {
    var fileFeed = this.getFileFeed(fileItem.getId());
    if (fileFeed && fileFeed.hasItem(fileItem.getId())) {
        fileFeed.refreshItem(fileItem);
    }
};

el8.apphome.docMgr.Organizer.prototype.refreshImageById = function(imageId) {
    var fileFeed = this.getFileFeed(imageId);
    if (fileFeed && fileFeed.hasItem(imageId)) {
        fileFeed.refreshImage(imageId);
    }
};

el8.apphome.docMgr.Organizer.prototype.markInboxStale = function(inboxId) {
    if (inboxId) {
        this._feeds[inboxId].markNeedsUpdate();
        this._tabbedNav.highlightTabCount(inboxId);
    }
};

el8.apphome.docMgr.Organizer.prototype.updateFileGroupProcessing = function(inboxId, fileGroupId, percentProcessed) {
    this._feeds[inboxId].updateFileGroupProcessing(fileGroupId, percentProcessed);
};

el8.apphome.docMgr.Organizer.prototype.updateFileGroupSuccess = function(inboxId, fileGroupId) {
    this._feeds[inboxId].updateFileGroupSuccess(fileGroupId);
};

el8.apphome.docMgr.Organizer.prototype.updateFileGroupError = function(inboxId, fileGroup) {
    this._feeds[inboxId].updateFileGroupError(fileGroup);
};

el8.apphome.docMgr.Organizer.prototype.queueFileItem = function(fileItem) {
    var fileFeed = this.getFileFeed(fileItem.getId());
    if (fileFeed && fileFeed.hasItem(fileItem.getId())) {
        fileFeed.refreshItem(fileItem);
    }
};

el8.apphome.docMgr.Organizer.prototype.dequeueFileItem = function(fileItem) {
    var fileFeed = this.getFileFeed(fileItem.getId());
    if (fileFeed && fileFeed.hasItem(fileItem.getId())) {
        fileFeed.refreshItem(fileItem);
    }
};

el8.apphome.docMgr.Organizer.prototype.removeFileItem = function(fileItemId) {
    var fileFeed = this.getFileFeed(fileItemId);
    if (fileFeed) { fileFeed.remove(fileItemId, el8.util.consts.DEFAULT_DURATION); }
};

/**
 * Helper actions to maintain hash from fileId to inboxId, fileGroupId
 */
el8.apphome.docMgr.Organizer.prototype.getFileFeed = function(fileId) {
    var map = this._fileIdMap[fileId];
    if (map) { // otherwise file hasn't been loaded
        var inboxFeed = this._feeds[map.inboxId];
        if (inboxFeed && inboxFeed.hasItem(map.fileGroupId)) {
            var fileFeed = inboxFeed.getFileFeed(map.fileGroupId);
            return fileFeed || null;
        }
        return null;
    }
    return null;
};


/**
 * Helper actions for feeds
 */
el8.apphome.docMgr.Organizer.prototype.addToFileIdMap = function(fileId, inboxId, fileGroupId) {
    this._fileIdMap[fileId] = {
        inboxId: inboxId,
        fileGroupId: fileGroupId
    };
};
el8.apphome.docMgr.Organizer.prototype.removeFromFileIdMap = function(fileId) {
    delete this._fileIdMap[fileId];
};
el8.apphome.docMgr.Organizer.prototype._showFeed = function(feedId) {
    if (feedId) {
        this._feeds[feedId].display();
        if (this._showFeedFn) { this._showFeedFn(); }
    }
};
el8.apphome.docMgr.Organizer.prototype._hideFeed = function(feedId) {
    if (feedId) {
        this._feeds[feedId].hide();
        this._feeds[feedId].pauseHover();
    }
};
